import React from 'react';
import PropTypes from 'prop-types';

ContainerName.propTypes = {
    name: PropTypes.string.isRequired
};

function ContainerName({name}) {
    return (
        <span
            style={{
                fontSize: '14px',
                lineHeight: 'normal',
                fontWeight: 600
            }}
        >
          {name}
        </span>
    );
}

export default ContainerName;
